import { render } from "./AllSync.vue?vue&type=template&id=f35bb6ac&scoped=true"
import script from "./AllSync.vue?vue&type=script&lang=js"
export * from "./AllSync.vue?vue&type=script&lang=js"

import "./AllSync.vue?vue&type=style&index=0&id=f35bb6ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f35bb6ac"

export default script